"use client";

import type { FC, PropsWithChildren } from "react";
import { createContext, useContext } from "react";

export type LanguageAlternates = Record<string, string>; // locale -> URL path (without locale prefix)

const LanguageAlternatesContext = createContext<LanguageAlternates>({});

export const LanguageAlternatesProvider: FC<PropsWithChildren<{ alternates: LanguageAlternates }>> = ({
  children,
  alternates,
}) => <LanguageAlternatesContext.Provider value={alternates}>{children}</LanguageAlternatesContext.Provider>;

export const useLanguageAlternates = () => useContext(LanguageAlternatesContext);
